import { Head } from '@inertiajs/react'
import { format } from 'date-fns'

type Pomodoro = {
  id: number
  start_time: string
  end_time: string | null
  duration: number
  type: string
  completed: boolean
  status: string
  task_id: number | null
  actual_duration?: number | null
  time_left?: number | null
  task?: { id: number; title: string } | null
}

const statusBadge = (status: string) => {
  const map: Record<string, [string, string]> = {
    started: ['bg-blue-100 text-blue-800', '进行中'],
    paused: ['bg-yellow-100 text-yellow-800', '已暂停'],
    completed: ['bg-green-100 text-green-800', '已完成'],
  }
  const [cls, label] = map[status] ?? ['bg-gray-100 text-gray-800', '未知']
  return <span className={`px-2 py-1 text-xs font-semibold rounded-full ${cls}`}>{label}</span>
}

const secs = (s?: number | null) => (s ? `${Math.floor(s / 60)}m ${s % 60}s` : '-')

export default function History({ pomodoros }: { pomodoros: Pomodoro[] }) {
  return (
    <div className="py-8 px-4 sm:px-6 lg:px-8">
      <Head title="历史记录" />
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-center text-gray-900 mb-8">番茄钟历史记录</h1>

        {pomodoros.length === 0 ? (
          <div className="text-center py-8 text-gray-500">暂无番茄钟记录</div>
        ) : (
          <div className="bg-white shadow-md rounded-lg overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  {['开始时间', '结束时间', '持续时间 (分钟)', '实际时长', '剩余时间', '类型', '状态', '关联任务'].map((h) => (
                    <th key={h} scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {pomodoros.map((p) => (
                  <tr key={p.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {format(new Date(p.start_time), 'yyyy-MM-dd HH:mm:ss')}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {p.end_time ? format(new Date(p.end_time), 'yyyy-MM-dd HH:mm:ss') : '-'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{p.duration}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{secs(p.actual_duration)}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{secs(p.time_left)}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span
                        className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                          p.type === 'work' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'
                        }`}
                      >
                        {p.type === 'work' ? '工作' : '休息'}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">{statusBadge(p.status)}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{p.task ? p.task.title : '无任务'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}
